import { useDispatch, useSelector } from "react-redux";
import { changeMenuSubitem } from "../redux/actions";

export const ConditionsSwitch = () => {
    const dispatch = useDispatch()
    const showConditionsFirst = useSelector(state => state.user.showConditionsFirst)
    const conditions = useSelector(state => state.user.conditions) ?? '';
    const lang = useSelector(state => state.app.currentLang)
    const hasActiveGame = useSelector(state => state.user.hasActiveGame)
    const menuSubitem = useSelector(state => state.app.menuSubitem)
    const isPartnerEnabled = useSelector(state => state.user.isPartnerEnabled)
    const showLink = useSelector(state => state.user.showLink)
    const gifts = useSelector(state => state.game.gameShop.gifts)
    const isSameTab = useSelector(state => state.game.gameShop.settings?.isSameTab);
    const wheelStatus = useSelector(state => state.game.gameWheel?.settings?.status)
    const shopStatus = useSelector(state => state.game.gameShop?.settings?.status)
    let counter = 0;
    if ( typeof wheelStatus === 'string' && wheelStatus !== "archived") counter++;
    if (conditions.length > 0) counter++;
    if ( typeof shopStatus === 'string' && shopStatus !== "archived"  && gifts.length && ((isSameTab === 0 && typeof wheelStatus === 'string' && wheelStatus !== "archived") || wheelStatus === "archived")) counter++;
    if (counter === 0) return null;
    return (
        <>
            <div className="conditionsSwitch">
                <div className={"conditionsSwitch__btns conditionsSwitch__btns-" + counter}>
                    {
                        showConditionsFirst === 1 && conditions.length > 0 && (
                            <div
                                className={'conditionsSwitch__btn ' + (menuSubitem === 'conditionals' ? 'active' : '')}
                                onClick={() => dispatch(changeMenuSubitem('conditionals'))}>
                                <span>{lang.submenu2}</span>
                            </div>
                        )
                    }
                    {
                        hasActiveGame && typeof wheelStatus === 'string' && wheelStatus !== 'archived' && (
                            <div
                                className={'conditionsSwitch__btn ' + (menuSubitem === 'games' ? 'active' : '')}
                                onClick={() => dispatch(changeMenuSubitem('games'))}>
                                <span>{lang.submenu1}</span>
                            </div>
                        )
                    }
                    {
                        hasActiveGame && typeof shopStatus === 'string' && shopStatus !== 'archived' && (isSameTab === 0 || (isSameTab === 1 && (wheelStatus === 'archived' ||  typeof wheelStatus !== 'string') )) && gifts.length > 0 && (
                            <div
                                className={'conditionsSwitch__btn ' + (menuSubitem === 'shop' ? 'active' : '')}
                                onClick={() => dispatch(changeMenuSubitem('shop'))}>
                                <span>{lang.submenu4}</span>
                            </div>
                        )
                    }
                    {
                        showConditionsFirst !== 1 && conditions.length > 0 && (
                            <div
                                className={'conditionsSwitch__btn ' + (menuSubitem === 'conditionals' ? 'active' : '')}
                                onClick={() => dispatch(changeMenuSubitem('conditionals'))}>
                                <span>{lang.submenu2}</span>
                            </div>
                        )
                    }
                </div>
            </div>
            {
                conditions.length > 0 && menuSubitem === 'conditionals' && (
                    <div className="conditionsText">
                        <div dangerouslySetInnerHTML={{ __html: conditions.replaceAll("\n", '<br/>') }} />
                        {
                            isPartnerEnabled === 0 && showLink === 1 && (
                                <>
                                    <br />
                                    <div dangerouslySetInnerHTML={{ __html: lang.message3.replaceAll("\n", '<br/>') }} />
                                </>
                            )
                        }
                    </div>
                )
            }
        </>
    )
}